import dayjs from 'dayjs'
import React from 'react'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import TableMui from 'src/components/TableMui'
import { useReceivement } from 'src/hooks/useReceivement'
import { useSelector, useStore } from 'src/utils/store'
import { actions } from '../../ReceivementOverviewListState'

export const ReceivementsTable = () => {
  const dispatch = useDispatch()
  const store = useStore()
  const history = useHistory()
  const { supervisorBadge } = useReceivement({ validateSupervisor: true })

  const receivementOverviewList = useSelector((state) => state.receivementOverviewList.receivements)
  const totalPages = useSelector((state) => state.receivementOverviewList.totalPages)
  const pageSizeState = useSelector((state) => state.receivementOverviewList.pageSize)
  const totalItems = useSelector((state) => state.receivementOverviewList.totalItems)
  const pageState = useSelector((state) => state.receivementOverviewList.page)

  const resolveTableRows = receivementOverviewList.map((receivementOverview) => ({
    ...receivementOverview,
  }))

  const onChangePage = React.useCallback((page: number) => {
    dispatch(actions.getReceivementOverviewList({ badge: supervisorBadge, page: page + 1 }))
  }, [dispatch, supervisorBadge])

  const onChangeRowsPerPage = React.useCallback((pageSize: number) => {
    dispatch(actions.getReceivementOverviewList({ badge: supervisorBadge, pageSize }))
  }, [dispatch, supervisorBadge])

  const onRowClick = React.useCallback(({ id }) => {
    history.push(`/receivement/${id}/details`)
    const { startDate, endDate } = store.getState().receivementOverviewList

    if (!startDate && !endDate) dispatch(actions.setDateInterval({ startDate: dayjs().subtract(1, 'week').startOf('day'), endDate: dayjs().endOf('day') }))
  }, [dispatch, history, store])

  return (
    <TableMui
      columns={[
        { id: 'fulfillmentCenterName', label: 'FC' },
        {
          id: 'startedAt', label: 'Data Início', isDate: true, dateFormat: 'DD/MM/YYYY',
        },
        { id: 'listNumberArId', label: 'N° das ARs' },
        { id: 'supplierName', label: 'Fornecedor' },
        { id: 'status', label: 'Status' },
      ]}
      rows={resolveTableRows}
      thinLine
      enablePagination
      rowsPerPageLimit={pageSizeState}
      onChangePage={onChangePage}
      onChangeRowsPerPage={onChangeRowsPerPage}
      resizable
      totalPages={totalPages}
      onRowClick={onRowClick}
      emptyLabel='Nenhum recebimento encontrado'
      currentPage={pageState - 1}
      totalItems={totalItems}
    />
  )
}
